"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userSourceOptions = void 0;
var userSourceOptions = exports.userSourceOptions = [{
  value: '1',
  label: 'Wifi',
  tag: 'default'
}, {
  value: '2',
  label: '摄像头',
  tag: 'warning'
}, {
  value: '3',
  label: '渠道1',
  tag: ''
},
// { value: '101', label: '渠道1', tag: '' },
{
  value: '102',
  label: '渠道2',
  tag: ''
}, {
  value: '103',
  label: '渠道3',
  tag: ''
}, {
  value: '104',
  label: '渠道4',
  tag: ''
}, {
  value: '105',
  label: '渠道5',
  tag: ''
}, {
  value: '106',
  label: '渠道6',
  tag: ''
}, {
  value: '107',
  label: '渠道7',
  tag: ''
}, {
  value: '108',
  label: '渠道8',
  tag: ''
}];